import type { ListItemTextProps } from "@mui/material";
import { ListItemText } from "@mui/material";

const DataListItemText = (props: ListItemTextProps) => {
  return (
    <ListItemText
      sx={{ whiteSpace: "wrap" }}
      slotProps={{
        primary: {
          "data-testid": "notification-item-title",
        },
        secondary: {
          "data-testid": "notification-item-description",
          variant: "caption",
          color: "text.secondary",
        },
      }}
      {...props}
    />
  );
};

export default DataListItemText;
